import create from "zustand";
import {immer} from 'zustand/middleware/immer'
import {TicketDestinations} from "@/components/Ticket/types";
import {SortParams} from "@/components/SortIndicator";
import {SortPostParams} from "@/containers/admin/Information/InformationList"

export const TicketDestinationsHeader = [
  {
    headerName:'プロジェクト',
    sortItemName: 'project_id',
  },
  {
    headerName:'送信先名',
    sortItemName: 'name',
  },
  {
    headerName:'送信先アドレス',
    sortItemName: 'email_address',
  },
];

const initState = {
  queryParams: undefined,
  ticketDestinations: undefined,
  childSubmit: () => {
  },
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type TicketDestinationsStore = {
  queryParams: SortPostParams | undefined;
  ticketDestinations: TicketDestinations[] | undefined;
  setTicketDestinations: (
    ticketDestinations: TicketDestinations[] | undefined
  ) => void;
  setQueryParams: (any: SortPostParams | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: TicketDestinationsStore['doSort']) => void;
};

export const useTicketDestinationsStore = create<TicketDestinationsStore>()(
  immer((set) => ({
    ...initState,
    setTicketDestinations: (ticketDestinations) =>
      set((state) => ({
        ticketDestinations: ticketDestinations,
      })),
    setQueryParams: (queryParams) =>
      set((state) => ({
        queryParams: queryParams,
      })),
    setSortParams: (sortParams) =>
      set((state) => ({
        sortParams: sortParams,
      })),
    setDoSort: (doSort) =>
      set((state) => ({
        doSort: doSort,
      }))
  }))
);
